import React, { createContext, useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { masterAdminAPI } from "../services/api";
import toast from "react-hot-toast";

const MasterAuthContext = createContext({});
export const useMasterAuth = () => useContext(MasterAuthContext);

export const MasterAuthProvider = ({ children }) => {
  const [masterUser, setMasterUser] = useState(null);
  const [masterToken, setMasterToken] = useState(
    () => localStorage.getItem("master_token")
  );
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  const isTokenValid = (token) => {
    if (!token) return false;
    try {
      const decoded = jwtDecode(token);
      return decoded.exp > Date.now() / 1000;
    } catch {
      return false;
    }
  };

  useEffect(() => {
    const init = async () => {
      if (!masterToken || !isTokenValid(masterToken)) {
        localStorage.removeItem("master_token");
        localStorage.removeItem("master_user");
        setLoading(false);
        return;
      }

      const storedUser = localStorage.getItem("master_user");
      if (storedUser) {
        setMasterUser(JSON.parse(storedUser));
      }

      setLoading(false);
    };

    init();
  }, [masterToken]);

  const masterLogin = async (email, password) => {
    try {
      const response = await masterAdminAPI.login({ email, password });
      const { access_token, user } = response.data;

      localStorage.setItem("master_token", access_token);
      localStorage.setItem("master_user", JSON.stringify(user));

      setMasterToken(access_token);
      setMasterUser(user);

      toast.success("Master login successful");
      navigate("/master/dashboard");

      return { success: true };
    } catch (error) {
      toast.error(error.response?.data?.detail || "Login failed");
      return { success: false };
    }
  };

  const masterLogout = () => {
    localStorage.removeItem("master_token");
    localStorage.removeItem("master_user");
    setMasterUser(null);
    setMasterToken(null);
    navigate("/master/login");
  };

  return (
    <MasterAuthContext.Provider
      value={{
        masterUser,
        masterToken,
        masterLogin,
        masterLogout,
        isMasterAuthenticated: !!masterUser && isTokenValid(masterToken),
      }}
    >
      {!loading && children}
    </MasterAuthContext.Provider>
  );
};